import { render, staticRenderFns } from "./IndexBannerItems.vue?vue&type=template&id=a1051aca&"
import script from "./IndexBannerItems.vue?vue&type=script&lang=js&"
export * from "./IndexBannerItems.vue?vue&type=script&lang=js&"
import style0 from "./IndexBannerItems.vue?vue&type=style&index=0&id=a1051aca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports